import React from "react";

export default class PageHeader extends React.Component {
  componentDidMount() {
    this.InitialSetup();
  }
  async InitialSetup() {
        
  }
  render() {
    return (
      <div className="page-header">
        <div className="page-leftheader">
          <h4 className="page-title mb-0">Hi! {localStorage.getItem("username")}</h4>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <label><i className="fe fe-home mr-2 fs-14"></i>Main</label>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              <label>{this.props.title}</label>
            </li>
          </ol>
        </div>
      </div>
    )
  }
}